import React from "react";
import { Box, InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBox = ({ value, onChange, placeholder }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        backgroundColor: "#f9f9f9",
        border: "1px solid #e0e0e0",
        borderRadius: "50px",
        padding: "4px 16px",
        width: {
          xs: "100%",
          sm: "300px",
          md: "400px",
        },
        maxWidth: "100%",
        height: "50px",
      }}
    >
      <SearchIcon sx={{ color: "#9e9e9e", marginRight: "8px" }} />
      <InputBase
        placeholder={placeholder || ""}
        value={value}
        onChange={onChange}
        sx={{
          flex: 1,
          color: "#757575",
          fontSize: "14px",
        }}
      />
    </Box>
  );
};

export default SearchBox;
